import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.scans };
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.scans };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.refreshScansSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.scans };
    },

})


